import { Link } from 'react-router-dom';
import { UncontrolledTooltip } from 'reactstrap';

import { getInfo, keyOf } from '@Components/Grid/components/Table/formatters';

export default function EntityTipFormatter({ info }) {
  const { row } = getInfo(info)
  const id = keyOf(info, 'entity')

  const { entity_id, entity, content_type } = row

  if (entity_id) {
    return <div>
      <Link
        id={id}
        to={`/cms/${content_type}/${entity === 'tag' ? `tags/${entity_id}` : entity_id}`}
        className="text-secondary btn-link"
      >
        <span>{entity}</span>
      </Link>
      <UncontrolledTooltip placement="right" target={id}>
        ID: {entity_id}
      </UncontrolledTooltip>
    </div>
  }

  return <div>
    <span id={id} >{entity}</span>
    <UncontrolledTooltip placement="right" target={id}>
      ID: {entity_id}
    </UncontrolledTooltip>
  </div>
}
